module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Document-c4de4386eb54ea4428ff50f534b63b0a.png";